"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var controllers_1 = require("@wix/social-groups-common/dist/src/controllers");
var types_1 = require("@wix/social-groups-api/dist/src/types");
var social_groups_api_1 = require("@wix/social-groups-api");
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var baseUrl_1 = require("@wix/social-groups-common/dist/src/baseUrl");
var wix_experiments_1 = require("@wix/wix-experiments");
var constants_1 = require("../../config/constants");
var MEMBERS_WITH_MY_APPROVAL = types_1.ApiTypes.v1.CreateGroupsPolicy.MEMBERS_WITH_MY_APPROVAL;
var BaseGroupsController = /** @class */ (function (_super) {
    tslib_1.__extends(BaseGroupsController, _super);
    function BaseGroupsController(controllerConfig, experiments) {
        if (experiments === void 0) { experiments = {}; }
        var _this = _super.call(this, controllerConfig) || this;
        _this.goToGroup = function (groupId) {
            _this.setState({ navigatingToGroup: groupId });
            if (_this.isEditorMode()) {
                _this.navigateInEditor(groupId);
            }
            else {
                var prefix = _this.getGroupPagePrefix();
                var groupToNavigate = _this.groupListModel.getGroupById(groupId);
                var tabToNavigate = 'discussion';
                if (groupToNavigate) {
                    var groupModel = social_groups_api_1.Group.getGroupResponseWrapper(groupToNavigate);
                    if (!social_groups_api_1.isJoined(groupToNavigate) &&
                        groupModel.getPrivacy() !== types_1.ApiTypes.v1.GroupPrivacyLevel.PUBLIC) {
                        tabToNavigate = 'about';
                    }
                    _this.cacheGroup(groupToNavigate);
                }
                // Implementation note:
                // We are using location.to with argument pageURL#<corvid-element-id>,
                // where <corvid-element-id> is  an invalid id. So it would fallback to the same scroll position without a scroll to top.
                _this.wixCodeApi.location.to(prefix + "/" + groupId + "/" + tabToNavigate + "#preventScrollToTop");
            }
        };
        _this.createGroup = function (details, settings, image) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var group, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            isGroupCreating: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.groupModel.create(details, settings, image)];
                    case 2:
                        group = _a.sent();
                        this.setState({
                            groups: (this.state.groups || []).concat([group]),
                        });
                        this.cacheGroup(group);
                        this.goToGroup(group.slug);
                        if (this.state.createGroupPolicy === MEMBERS_WITH_MY_APPROVAL &&
                            !social_groups_api_1.isUserSiteAdmin(this.getCurrentUser())) {
                            this.platformAPIs.pubSub.publish(social_groups_api_1.APP_TOAST_EVENT, {
                                type: social_groups_api_1.AppToastTypes.GROUP_CREATED_IN_PENDING_STATE,
                                options: {
                                    'group-name': group.details.title,
                                },
                            }, false);
                            return [2 /*return*/];
                        }
                        this.platformAPIs.pubSub.publish(social_groups_api_1.APP_TOAST_EVENT, {
                            type: social_groups_api_1.AppToastTypes.GROUP_CREATED,
                            options: {
                                'group-name': group.details.title,
                            },
                        }, false);
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        // TODO: handle error
                        console.error(e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.setState({
                            isGroupCreating: false,
                        });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.fetchGroupsInstanceSettings = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getGroupInstanceSettings()];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.settings];
                    case 2:
                        e_2 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_2);
                        return [2 /*return*/, {}];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleGroupCardCTA = function (group) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var relationship, slug;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        relationship = group.relationship, slug = group.slug;
                        if (relationship === types_1.ApiTypes.v1.RelationshipWithGroup.JOINED) {
                            this.goToGroup(slug);
                            return [2 /*return*/];
                        }
                        if (!!this.isUserLoggedIn()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.promptLogin()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.maybeChangeMembership(group)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.setGroups(this.config)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.makeProfilePublic = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var member, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.api.members.updateSiteMemberPrivacy(siteMemberId, social_groups_api_1.SiteMemberPrivacyStatus.PUBLIC)];
                    case 1:
                        member = (_a.sent()).data.member;
                        this.setState({
                            currentSiteMember: member,
                            promptPublicProfile: false,
                        });
                        if (!this.waitingJoinGroup) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.handleGroupCardCTA(this.waitingJoinGroup)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        console.error('Update site member profile: FAIL', e_3);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var appParams = controllerConfig.appParams, wixCodeApi = controllerConfig.wixCodeApi, platformAPIs = controllerConfig.platformAPIs, config = controllerConfig.config;
        _this.experiments = new wix_experiments_1.default({ experiments: experiments });
        _this.platformAPIs = platformAPIs;
        _this.wixCodeApi = wixCodeApi;
        _this.config = config;
        _this.initExternalServices(appParams.instance);
        _this.onUserLogin(function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.initExternalServices(instance);
                            return [4 /*yield*/, this.setGroups(this.config)];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        });
        return _this;
    }
    BaseGroupsController.prototype.updateConfig = function ($w, updatedConfig) {
        return this.setGroups(updatedConfig);
    };
    BaseGroupsController.prototype.setGroups = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groups;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGroups(config)];
                    case 1:
                        groups = _a.sent();
                        this.setState({ groups: groups });
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseGroupsController.prototype.navigateInEditor = function (groupId) {
        if (typeof window !== 'undefined') {
            window.Wix.Utils.navigateToSection({
                sectionId: 'group',
                state: '',
                queryParams: { groupId: groupId },
            }, console.error);
        }
        else {
            this.wixCodeApi.location.to('https://groups.wixapps.net/social-groups/api/render/social-group/editorApp');
        }
    };
    BaseGroupsController.prototype.cacheGroup = function (groupToNavigate) {
        try {
            var groupId = groupToNavigate.groupId, slug = groupToNavigate.slug;
            this.controllerConfig.platformAPIs.storage.memory.setItem(groupId, JSON.stringify(groupToNavigate));
            this.controllerConfig.platformAPIs.storage.memory.setItem(slug, JSON.stringify(groupToNavigate));
        }
        catch (e) {
            console.log('Failed to write a group object to platformAPIs storage');
        }
    };
    BaseGroupsController.prototype.pageReady = function ($w, wixAPI) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentSiteMember;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Props after SSR
                        this.setState({ actions: this.getActions() });
                        return [4 /*yield*/, this.getCurrentSiteMember()];
                    case 1:
                        currentSiteMember = _a.sent();
                        this.setState({ currentSiteMember: currentSiteMember, navigatingToGroup: null });
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    BaseGroupsController.prototype.getActions = function () {
        return {
            createGroup: this.createGroup,
            goToGroup: this.goToGroup,
            promptLogin: this.promptLogin,
            handleGroupCardCTA: this.handleGroupCardCTA,
            makeProfilePublic: this.makeProfilePublic,
        };
    };
    BaseGroupsController.prototype.withdrawJoinRequest = function (group) {
        // Need this because of refreshing `groupModel` in `this.initExternalServices`
        return this.groupModel.withdrawJoinRequest(group);
    };
    BaseGroupsController.prototype.joinGroup = function (group) {
        // Need this because of refreshing `groupModel` in `this.initExternalServices`
        return this.groupModel.joinGroup(group);
    };
    BaseGroupsController.prototype.getGroupPagePrefix = function () {
        try {
            var siteStructure = this.wixCodeApi.site
                .getSiteStructure();
            var appDefinitionId_1 = this.controllerConfig.appParams.appDefinitionId;
            var groupPage = siteStructure.prefixes.find(function (page) {
                return page.applicationId === appDefinitionId_1 &&
                    page.name === constants_1.GROUP_PAGE_NAME;
            });
            return groupPage.prefix;
        }
        catch (e) {
            console.error('Get Group Page prefix: FAIL');
        }
        return '/group';
    };
    BaseGroupsController.prototype.initExternalServices = function (instance) {
        this.api = new social_groups_api_1.default(instance, baseUrl_1.default(this.wixCodeApi));
        this.groupModel = new social_groups_api_1.Group('', this.api, this.platformAPIs);
        this.groupListModel = new social_groups_api_1.GroupList(this.api);
    };
    BaseGroupsController.prototype.maybeChangeMembership = function (group) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentSiteMember;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrentSiteMember()];
                    case 1:
                        currentSiteMember = _a.sent();
                        if (!social_groups_api_1.isProfilePublic(currentSiteMember)) {
                            //prompt change
                            this.setState({ promptPublicProfile: true });
                            this.waitingJoinGroup = group;
                            return [2 /*return*/];
                        }
                        this.waitingJoinGroup = null;
                        switch (group.relationship) {
                            case types_1.ApiTypes.v1.RelationshipWithGroup.PENDING_APPROVAL:
                                return [2 /*return*/, this.withdrawJoinRequest(group)];
                            case types_1.ApiTypes.v1.RelationshipWithGroup.REJECTED_MEMBERSHIP:
                            case types_1.ApiTypes.v1.RelationshipWithGroup.NONE:
                                return [2 /*return*/, this.joinGroup(group)];
                            default:
                                console.warn('Unknown relationship', group.relationship);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseGroupsController.prototype.getCurrentSiteMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var member, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state.currentSiteMember) {
                            //TODO: where is state updated?
                            return [2 /*return*/, Promise.resolve(this.state.currentSiteMember)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.members.getCurrentSiteMember()];
                    case 2:
                        member = (_a.sent()).data.member;
                        return [2 /*return*/, member];
                    case 3:
                        e_4 = _a.sent();
                        console.error('Get current site member profile: FAIL', e_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return BaseGroupsController;
}(controllers_1.BaseWidgetController));
exports.BaseGroupsController = BaseGroupsController;
//# sourceMappingURL=BaseGroupsController.js.map